"use strict";

import { PREPEND } from "@/helpers/constants";
import { fetchInstance, type Config } from "@/services/fetch";

const baseURL = import.meta.env.VITE_BACKEND_URL;

const instance = fetchInstance.instanciate({ baseURL });

instance.interceptors.response(
  async (response) => {
    const message = await response.json();

    if (response.status === 419) {
      console.table({
        Title: `${PREPEND} 🍪`,
        Message: message.message,
        Support: message.link || import.meta.env.VITE_SUPPORT_URL || "https://cookiedock.com",
      });

      return response;
    }

    return response;
  },
  (error) => null,
);

export const api = {
  get: <T>(url: string, ...config: Config[]): Promise<T> => instance.create<T>("GET", url, ...config),
  post: <T>(url: string, ...config: Config[]): Promise<T> => instance.create<T>("POST", url, ...config),
  patch: <T>(url: string, ...config: Config[]): Promise<T> => instance.create<T>("PATCH", url, ...config),
  put: <T>(url: string, ...config: Config[]): Promise<T> => instance.create<T>("PUT", url, ...config),
  delete: <T>(url: string, ...config: Config[]): Promise<T> => instance.create<T>("DELETE", url, ...config),
};
